import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/components.css";
import "./styles/app.css";

import { VaultProvider } from "./hooks/useVault.jsx";
import { ToastProvider } from "./hooks/useToast.jsx";
import { Root } from "./App.jsx";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <ToastProvider>
      <VaultProvider>
        <Root />
      </VaultProvider>
    </ToastProvider>
  </StrictMode>
);
